import { ColDef, ColGroupDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { RefObject } from "react";
import { ColumnParams, ColumnWidth } from "../types/ag-grid-types";

export const setColumnWidths = <TData>(columnParams: { [key: string]: ColumnParams }, gridApiRef: RefObject<AgGridReact<TData>>, isGridReady: boolean) => {
  if (isGridReady && gridApiRef.current?.api != null) {
    const gridApi = gridApiRef.current.api;

    const widths: ColumnWidth[] = [];
    const nonPins: string[] = [];
    const leftPins: string[] = [];
    const rightPins: string[] = [];
    gridApi.getColumnDefs()?.values().forEach((value: ColDef<TData> | ColGroupDef<TData>) => {
      const colDef = value as ColDef;
      const colId = colDef.colId;

      if (colId) {
        const params = columnParams[colId];
        if (params) {
          if (params.width)
            widths.push({ key: colId, newWidth: params.width });
          if (params.pinned === "right")
            rightPins.push(colId);
          else if (params.pinned === "left" || params.pinned)
            leftPins.push(colId);
          else
            nonPins.push(colId);
        }
      }
    });

    if (widths.length > 0)
      gridApi.setColumnWidths(widths);

    if (nonPins.length > 0)
      gridApi.setColumnsPinned(nonPins, undefined);

    if (rightPins.length > 0)
      gridApi.setColumnsPinned(rightPins, "right");

    if (leftPins.length > 0)
      gridApi.setColumnsPinned(leftPins, "left");
  }
};
